import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumDocumentTagType implements BaseEnumType {
  private static allValues: EnumDocumentTagType[] = []; // make sure this is top-most
  
  public static string = new EnumDocumentTagType(0, "String", "enum_document_tag_type_string");
  public static currency = new EnumDocumentTagType(1, "Currency", "enum_document_tag_type_currency");
  public static integer = new EnumDocumentTagType(2, "Integer", "enum_document_tag_type_integer");
  public static long = new EnumDocumentTagType(3, "Long", "enum_document_tag_type_long");
  public static double = new EnumDocumentTagType(4, "Double", "enum_document_tag_type_double");
  public static boolean = new EnumDocumentTagType(5, "Boolean", "enum_document_tag_type_boolean");
  public static date = new EnumDocumentTagType(6, "Date", "enum_document_tag_type_date");
  public static time = new EnumDocumentTagType(7, "Time", "enum_document_tag_type_time");
  public static timestamp = new EnumDocumentTagType(8, "Timestamp", "enum_document_tag_type_timestamp");
  public static image = new EnumDocumentTagType(9, "Image", "enum_document_tag_type_image");
  public static array = new EnumDocumentTagType(10, "Array", "enum_document_tag_type_array");
  public static svg = new EnumDocumentTagType(11, "Svg", "enum_document_tag_type_svg");
  public static object = new EnumDocumentTagType(12, "Object", "enum_document_tag_type_object");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDocumentTagType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isString() { return this === EnumDocumentTagType.string; }
  public isCurrency() { return this === EnumDocumentTagType.currency; }
  public isInteger() { return this === EnumDocumentTagType.integer; }
  public isLong() { return this === EnumDocumentTagType.long; }
  public isDouble() { return this === EnumDocumentTagType.double; }
  public isBoolean() { return this === EnumDocumentTagType.boolean; }
  public isDate() { return this === EnumDocumentTagType.date; }
  public isTime() { return this === EnumDocumentTagType.time; }
  public isTimestamp() { return this === EnumDocumentTagType.timestamp; }
  public isImage() { return this === EnumDocumentTagType.image; }
  public isArray() { return this === EnumDocumentTagType.array; }
  public isSvg() { return this === EnumDocumentTagType.svg; }
  public isObject() { return this === EnumDocumentTagType.object; }

  public static getValues(): readonly EnumDocumentTagType[] {
    return EnumDocumentTagType.allValues;
  }

  public static getValuesExcept0(): readonly EnumDocumentTagType[] {
    return EnumDocumentTagType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDocumentTagType {
    const found = EnumDocumentTagType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDocumentTagType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDocumentTagType): EnumDocumentTagType {
    const found = name ? EnumDocumentTagType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDocumentTagType - Value not found: ${ name }`);
    }

    return found;
  }
}